import { render, staticRenderFns } from "./SinglePay.vue?vue&type=template&id=450f5350&"
import script from "./SinglePay.vue?vue&type=script&lang=js&"
export * from "./SinglePay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports